var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRating)?_c('v-rating',{attrs:{"dense":"","small":"","readonly":"","half-increments":"","length":"10","half-icon":"mdi-star-half-full","value":_vm.rating}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }